import { useCallback, useMemo } from 'react';

import { Modals } from '@components';
import { useBaseStore } from '@store';

export interface ModalHook {
	hide: () => void;
	show: () => void;
	isVisible: boolean;
}

export const useModal = (modalName: Modals): ModalHook => {
	const hideModal = useBaseStore((state) => state.hideModal);
	const showModal = useBaseStore((state) => state.showModal);
	const modals = useBaseStore((state) => state.modals);

	const show = useCallback(() => {
		showModal(modalName);
	}, [modalName, showModal]);

	const hide = useCallback(() => {
		hideModal(modalName);
	}, [modalName, hideModal]);

	const isVisible = useMemo(() => {
		return (modals?.[modalName] || 0) > 0;
	}, [modalName, modals]);

	return {
		hide,
		show,
		isVisible,
	};
};
